var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronicon = function SvgChevronicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 12 7",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 .754a.75.75 0 0 1 1.29-.52l4.75 4.93L10.696.239a.754.754 0 0 1 1.1 1.031L6.598 6.766a.75.75 0 0 1-1.085.005L.215 1.274A.74.74 0 0 1 0 .754"
  })));
};
export default SvgChevronicon;